module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-report-box-image-60248baad1fd5aaf353515d061454536.png";